import { FC } from 'react'
import styles from './ProductTagsSpecificationsTable.module.css'
import clsx from 'clsx'

interface Props {
  tags: string[] | undefined
}

const specificationTags = [
  'collection',
  'metal',
  'metal_colour',
  'metal_type',
  'metal_finish',
  'style',
  'type',
  'feature',
  'model_name',
  'range',
  'technology',
  'glass',
  'bezel_colour',
  'material',
  'material_type',
  'colour',
  'case_colour',
  'metal_colour',
  'dial_colour',
  'dial_material',
  'dial_shape',
  'band_colour',
  'function',
  'band_material',
  'gemstone',
  'feature_gemstone_setting',
  'feature_gemstone_colour',
  'feature_gemstone_shape',
  'feature_gemstone_clarity',
  'feature_gemstone_cut',
  'accent_gemstone_setting',
  'accent_gemstone_cut',
  'shape',
  'stone_class',
  'diamond_weight',
  'total_diamond_carat_weight',
  'construction',
  'chain',
  'chain_width',
  'clasp',
  'width',
  'diameter',
  'size',
  'lug_width',
  'display',
  'caliber',
  'Caliber',
  'movement',
]

const upperCaseTags = [
  'feature_gemstone',
  'feature_gemstone_colour',
  'model_number',
  'caliber',
]

function toTitleCase(string: string) {
  return string.replace(/\w\S*/g, function (text: string) {
    return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase()
  })
}

const ProductTagSpecificationsTable: FC<Props> = ({ tags }) => {
  if (!tags) return null

  const filteredTags = tags.filter((tag) =>
    specificationTags.includes(tag.split(':')[0])
  )

  if (!filteredTags.length) return null

  const format = (tag: string) => {
    const formattedTag = tag.replace(/_/g, ' ')

    return toTitleCase(formattedTag)
  }
  const formattedTagsArray = filteredTags.map((tag) => {
    const splitTag = tag.split(':')

    if (upperCaseTags.includes(splitTag[0])) {
      return {
        name: format(splitTag[0]),
        value: splitTag[1].toUpperCase(),
      }
    }

    return {
      name: format(splitTag[0]),
      value: format(splitTag[1]),
    }
  })

  const rootClass = clsx(styles.root, {
    [styles.wrapper]: true,
  })

  return (
    <div className={rootClass}>
      <div className={styles.textTable}>
        <div className={styles.textTable__heading}>
          <h5>SPECIFICATIONS</h5>
        </div>
        <div className="table">
          {formattedTagsArray.map((tag, index) => (
            <div className={styles.textTable__row} key={index}>
              <div className={styles.textTable__head}>{tag.name}</div>
              <div className={styles.textTable__data}>{tag.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProductTagSpecificationsTable
